import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';
import { HELP_CENTER_LINKS } from '../helpCenterLinks';

export const connectionsPageSteps = [
  {
    element: '[data-onboarding="connections-page"]',
    popover: {
      title: 'Integrations Dashboard',
      description:
        `Manage connections to <a href="${HELP_CENTER_LINKS.vms}" target="_blank" class="text-lime underline">VMS</a> platforms and other external services. Add new connections, and monitor their status. Check <a href="${HELP_CENTER_LINKS.integrations}" target="_blank" class="text-lime underline">here</a> for more information.`,
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="connections-add-button"]',
    popover: {
      title: 'Add New Connection',
      description:
        'Connect a new VMS or other external service to Watchful.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="connections-utility-bar"]',
    popover: {
      title: 'Search and Filter Tools',
      description:
        'Use the search bar to find integrations by name or type. Customize your view with column visibility and open the filters panel to narrow the connections list.',
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="connections-table"] table tbody, [data-onboarding="connections-table"] table',
    popover: {
      title: 'Connections Table',
      description:
        'All integrations are listed with key details such as name, type, status, and devices. Click a connection to view or edit its settings.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
];

export const connectionDetailSteps = [
  {
    element: '[data-onboarding="connection-detail-header"]',
    popover: {
      title: 'Connection Details',
      description:
        'View the connection name and navigate back to the list. Remember to Save before leaving the page.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="connection-detail-info-card"]',
    popover: {
      title: 'Connection Information',
      description: 'The connection name appears in the system.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="connection-detail-form"]',
    popover: {
      title: 'About this Connection',
      description:
        'Update the connection name and description here. Clear names and descriptions make it easier to find and manage your integrations.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="connection-detail-credentials"]',
    popover: {
      title: 'Device Credentials',
      description:
        'Use these credentials to connect your external service to Watchful. Copy the webhook URLs, tokens, or login details into your device settings. Use the copy buttons for quick, accurate setup.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="connection-detail-connection-form"]',
    popover: {
      title: 'Connection Details',
      description:
        'Set up integration-specific settings here. Enter any required credentials or options for your external service. Use Reindex Connection to refresh device data and check the connection is working.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="connection-detail-sidebar"]',
    popover: {
      title: 'Connection Sidebar',
      description:
        'Connection health, supported features, and management actions are displayed here. Check status and health at the top, see what this integration supports, or use the Danger Zone to delete the connection.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
];

export const connectionRoutes: RouteConfig[] = [
  {
    id: 'connections',
    processName: ONBOARDING_KEYS.connections,
    match: (path: string) => path === '/connections',
    steps: connectionsPageSteps,
  },
  {
    id: 'connection-detail',
    processName: ONBOARDING_KEYS.connectionDetail,
    match: (path: string) => /^\/connections\/[^/]+$/.test(path),
    steps: connectionDetailSteps,
  },
];
